import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

const navbarHeightStyles = css`
  height: 80px;
`;

export const FixedHeaderOffset = styled.div`
  ${navbarHeightStyles}
`;

export const StyledHeader = styled.header`
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: ${({ theme }) => theme.customTheme.palette.white.standard};

  ${navbarHeightStyles}
`;

export const OverlayContainer = styled.div<{
  visible: boolean;
}>`
  ${({ visible }) =>
    visible &&
    `
  z-index: 9999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  `}
`;

export const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding-left: 48px;
    padding-right: 48px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding-left: 32px;
    padding-right: 32px;
  }
`;

interface ILogoWrapper {
  $ofsetLogo?: boolean;
  $centerLogo?: boolean;
}

export const LogoWrapper = styled(Link)<ILogoWrapper>`
  height: 32px;
  width: 32px;
  z-index: 100;
  margin: 0;

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    margin-left: ${({ $ofsetLogo, $centerLogo }) => ($ofsetLogo && !$centerLogo ? "-24px" : "0")};
  }

  ${({ $centerLogo }) =>
    $centerLogo &&
    `
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  `}
`;
